import styles from './style.module.scss';

/** Shimmer placeholder shown while the profile request is in flight. */
function AccountSkeleton() {
    return (
        <div className={styles.container}>
            <section className={styles.section}>
                <h3>Account Information</h3>
                <div className={styles.row}>
                    <div className={styles.column}>
                        <div className={styles.skeletonBox} />
                        <div className={styles.skeletonBox} />
                    </div>
                    <div className={styles.column}>
                        <div className={styles.skeletonBox} />
                        <div className={styles.skeletonBox} />
                    </div>
                </div>
            </section>

            <section className={styles.section}>
                <h3>Company name:</h3>
                <div className={styles.logoSkeleton} />
                <div className={styles.skeletonBox} />
                <div className={styles.addressRow}>
                    <div className={styles.skeletonSmall} />
                    <div className={styles.skeletonSmall} />
                    <div className={styles.skeletonSmall} />
                    <div className={styles.skeletonSmall} />
                </div>
            </section>

            <section className={styles.section}>
                <h3>Account Seats</h3>
                <div className={styles.skeletonBox} />
            </section>

            <section className={styles.section}>
                <h3>Plan Information</h3>
                <div className={styles.skeletonBox} />
            </section>
        </div>
    );
};

export default AccountSkeleton;
